import { Paper, Typography, TextField, IconButton, Box } from '@mui/material';
import { ChangeEvent, FC, MouseEvent } from 'react';
import OverflowTooltip from '@shared/components/ui/OverflowTooltip';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';

interface PcapFileItemProps {
    pcapFile: { pk: number; name: string; cps: number };
    handleChangeCps: (pk: number) => (e: ChangeEvent<HTMLInputElement>) => void;
    handleDeletePcapFile: (pk: number) => (e: MouseEvent<HTMLButtonElement>) => void;
    handleDownloadPcapFile: (pk: number) => (e: MouseEvent<HTMLButtonElement>) => void;
}

const PcapFileItem: FC<PcapFileItemProps> = ({
    pcapFile,
    handleChangeCps,
    handleDeletePcapFile,
    handleDownloadPcapFile,
}) => {
    return (
        <Paper
            variant="outlined"
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, maxWidth: 600, p: 2 }}
        >
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <OverflowTooltip title={pcapFile.name} maxLines={2}>
                    <Typography sx={{ fontWeight: 700, width: 200 }}>{pcapFile.name}</Typography>
                </OverflowTooltip>
                <TextField
                    size="small"
                    type="number"
                    value={pcapFile.cps}
                    slotProps={{ htmlInput: { sx: { width: 60 }, min: 1 } }}
                    label="Cps"
                    onChange={handleChangeCps(pcapFile.pk)}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
                <IconButton onClick={handleDownloadPcapFile(pcapFile.pk)}>
                    <DownloadIcon />
                </IconButton>

                <IconButton size="small" color="error" onClick={handleDeletePcapFile(pcapFile.pk)}>
                    <DeleteIcon />
                </IconButton>
            </Box>
        </Paper>
    );
};

export default PcapFileItem;
